export function errorMessage(error, fallback = "The request failed. Please try again.") {
  if (typeof error === "string" && error.trim()) return error
  const data = error?.response?.data || error?.payload || error
  const details = (Array.isArray(data?.errors) ? data.errors : []).map((entry) =>
    typeof entry === "string" ? entry : [entry.field || entry.path, entry.msg || entry.message].filter(Boolean).join(": "))
  const message = data?.message || error?.message
  if (message || details.length) return [...new Set([message, ...details].filter(Boolean))].join(". ")
  return fallback
}

export function mutationError(error) {
  return Object.assign(new Error(errorMessage(error)), {
    status: error?.status || error?.response?.status,
    code: error?.code,
  })
}

// RTK dispatch promises resolve for rejected actions too. Keep the action shape
// for existing .then(result.payload) consumers, but reject actual failures.
export async function requireMutationSuccess(request) {
  const action = await request
  if (action?.meta?.requestStatus === "rejected" && !action.meta.condition) {
    throw mutationError(action.payload || action.error)
  }
  return action
}

export function savedLocally(result) {
  const value = result?.payload ?? result
  if (Array.isArray(value)) return value.some(savedLocally)
  return Boolean(value?._offlineQueued || value?.queued)
}
